import Vue from 'vue';
import Component from 'vue-class-component';
import { AvatarMixin } from './avatar-mixins';
import { ButtonMixin } from './button-mixins';
import { CardMixin } from './card-mixins';
import { ChipMixin } from './chip-mixins';
import { ControlMixin } from './control-mixin';
import { DialogMixin } from './dialog-mixins';
import { IconMixin } from './icon-mixins';
import { InputMixin } from './input-mixins';
import { SpaceMixin } from './space-mixins';
import { TabMixin } from './tab-mixins';
import { TableMixins } from './table-mixins';

@Component({
	mixins: [
		AvatarMixin,
		ButtonMixin,
		CardMixin,
		ChipMixin,
		ControlMixin,
		DialogMixin,
		InputMixin,
		IconMixin,
		SpaceMixin,
		TabMixin,
		TableMixins,
	],
})
export class StyleMixin extends Vue {}
